import {ROOT} from '@router/consts';
import BaseLink from '@components/Form/BaseLink/BaseLink';
import Logo from '@assets/icons/Logo';
import { Outlet } from 'react-router-dom';

const SurveyLayout = ({route}) => (
  // Phones and tablets (below 1280px): fit the visible screen (dvh, no address-bar scroll), smaller side padding, no sideways overflow
  <div className="bg-main min-h-screen h-full px-12 py-6 flex relative max-xl:px-6 max-xl:pt-24 max-xl:pb-8 max-xl:h-[100dvh] max-xl:min-h-0 max-xl:overflow-x-hidden max-xl:overflow-y-auto">
    <BaseLink to={ROOT} className="absolute top-10 left-10 cursor-pointer max-xl:top-6 max-xl:left-6"><Logo size="w-12 h-12 md:w-16 md:h-16" /></BaseLink>
    <Outlet />
  </div>
);

export default SurveyLayout;
